import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './RichTextEditableRenderer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "editor", staticClass: "rich-text-editable-renderer" },
    [
      _c("RichTextEditor", {
        attrs: {
          editable: _vm.isEditing,
          "empty-field-text": _vm.emptyFieldText,
          "base-url": _vm.baseUrl
        },
        on: { "edit-requested": _vm.onEditRequested },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(ref) {
              var setContent = ref.setContent;
              return [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "Button",
                      {
                        attrs: {
                          type: "submit",
                          "is-loading": _vm.isLoading,
                          "is-disabled": _vm.isDisabled,
                          appearance: "primary"
                        },
                        on: { click: _vm.onSave }
                      },
                      [_vm._v("\n                    Save\n                ")]
                    ),
                    _vm._v(" "),
                    _c("Button", { on: { click: _vm.onCancel } }, [
                      _vm._v("\n                    Cancel\n                ")
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.content,
          callback: function($$v) {
            _vm.content = $$v;
          },
          expression: "content"
        }
      }),
      _vm._v(" "),
      _vm.error
        ? _c("InlineErrorMessage", {
            attrs: {
              error: _vm.error,
              "target-element": _vm.$refs["editor"],
              placement: _vm.placement
            }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-2411ca26";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/RichTextEditableRenderer.vue.js